// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3AXYw","signatureBlock":"Footer_signatureBlock__2u0ud","signature":"Footer_signature__boT3B"};